import { Link } from "react-router-dom";
import { LOGO_FULL } from "@/lib/assets";

export const Logo = ({ className = "" }) => {
  return (
    <Link to="/" data-testid="logo-link" className={`inline-flex items-center group ${className}`}>
      <img
        src={LOGO_FULL}
        alt="Easy Booking Solutions logo"
        className="h-14 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
      />
    </Link>
  );
};

export default Logo;
